// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dragged-component:hover {
    background: #d7f3ff;
    border: 1px solid #008fc7;
}

.builder-actions {
    padding: 0;
    margin: 5px 0 3px 0;
    padding: 0;
}

.comp-drag-over {
    background: #ff979d;
}

.drag-target .comp-drag-over {
    background: #ff979d;
}
.bg-new{
    background-color: #faeced  !important
}
.page-container {
    border: 1px solid #00a1ff;
    border-style: dashed;
    border-radius: 5px;
    padding: 0;
    min-height: 78vh;
}

.add-new-comp {
    background: #008fc7;
    border: 0px !important;
    padding: 0.5em !important;
}

.plus-icon {
    margin-left: 5px;
}

.comp-item {
    padding: 0.8em;
    list-style-type: none;
    margin: 0.5em;
    color: #fff;
    border-radius: 5px;
    border: 1px solid #d0d0d0;
}

.comp-images {
    display: block;
    margin: auto;
    width: 100%;
}

.comp-name {
    color: white;
    text-align: center;
}

.comp-item-draggable {
    border: 1px white;
    margin-bottom: 15px;
}

.navbar {
    border-bottom: 1px solid white !important;
}

.block-actions {
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    background: #19b5fe;
    color: #fff;
    padding: 0px 5px;
    border-radius: 0 0px 5px 0px;
}

.block-actions .fas {
    margin: 0 10px;
}

.dragged-component:hover .block-actions {
    display: block;
}

.drop-zone {
    animation-delay: 0s;
    animation-duration: 0.5s;
    background: #d9eaf2;
    border-radius: 5px;
}

.fas.fa-arrow-left.fa-lg.btn {
    color: #008fc7 !important;
    cursor: pointer;
}

.preview-builder {
    border: transparent;
    background-color: rgba(0, 143, 199, 0.1);
    padding: 8px 20px;
    color: #008fc7;
}

.preview-builder.active {
    background-color: #008fc7;
    color: #f2f2f2;
}

.preview-builder.active:hover {
    background-color: rgba(0, 143, 199, 0.1);
    color: #008fc7;
}

.brl-5 {
    border-radius: 5px 0 0 5px;
}

.brr-5 {
    border-radius: 0 5px 5px 0;
}

.layout-btn {
    margin-right: 20px;
    border-right: 1px solid #ccc;
    padding-right: 20px;
}

.edit-layout-btn i {
    font-size: 21px;
}

.iframe-preview {
    height: 100vh;
    border: transparent;
    border-radius: 5px;
}

.from-template {
    background: #ffecb3;
}

.from-template .dragged-component {
    background: #ffecb3;
}

.sizing-block {
    display: block;
    position: absolute;
    bottom: 0;
    top: initial;
    left: initial;
    border-radius: 5px 5px 0px 0px;
    z-index: 10;
    cursor: pointer;
}

.sizing-pop .col input {
    display: inline-block;
    width: 35px;
}

.btn.btn-link:hover {
    background: transparent !important;
}

.searchText {
    color: #fff !important;
}

.alias-text {
    border: 0;
    border-radius: 5px;
}

.alias-text:active {
    border: 0;
}

.alias-text:focus {
    border: 0;
}

.text-center.add-blocks.action-block.inner {
    right: 15px;
}

.col-style.col-style-temp .row {
    margin-right: 15px;
    margin-left: 15px;
}

.row-style.text-center.row {
    padding: 0 25px;
}

.drag-handle i.fas.fa-arrows-alt {
    z-index: 1;
}
.text-center.add-blocks.action-block.inner {
    right: 0px !important;
}

.text-center.add-blocks.action-block.inner.inner-col {
    margin-right: 0px !important;
}

.inner-block {
    background: repeating-linear-gradient(45deg, #e4f3f8, #fff 10px, #e4f3f8 0, #e4f3f8 20px);
}

.inner-block .text-center {
    padding: 40px 0 40px 0;
    color: #005b88;
    font-size: 16px;
    line-height: 24px;
}
.col-style.drag-target{
    border-color: transparent!important;
}
.json-file{
    display: flex;
    justify-content: end;
    font-size: 23px;
    color:#008fc7;
}
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    position: relative;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    padding: 24px;
    width: 90%;
    max-width: 800px;
    overflow: hidden;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .close-button {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 24px;
    color: #333;
    cursor: pointer;
  }

  .header {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 16px;
    text-align: center;
    color: #1976d2;
  }

  .search-bar {
    width: 100%;
    margin-bottom: 24px;
  }

  .cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
  }

  .card {
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    background-color: #fff;
    cursor: pointer;
  }

  .card:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  }

  .card-image {
    width: 100%;
    height: 150px;
    object-fit: cover;
  }

  .card-content {
    padding: 16px;
    text-align: left;
  }

  .card-content h3 {
    font-size: 1.2rem;
    margin: 0 0 8px;
    color: #333;
  }

  .card-content p {
    margin: 0;
    font-size: 0.9rem;
    color: #666;
  }

  .pagination-controls {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
  }

  .no-templates {
    text-align: center;
    padding: 24px;
  }

  .no-templates-image {
    width: 100%;
    max-width: 300px;
    margin-bottom: 16px;
  }

  .no-templates-title {
    font-size: 1.5rem;
    color: #555;
  }
  .modal-content {
    position: relative;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    padding: 24px;
    width: 90%;
    max-width: 800px;
    max-height: 90vh; /* Ensure the modal does not exceed 90% of the viewport height */
    overflow-y: auto; /* Enable scrolling for content overflow */
  }
  
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
  }
  
  .pagination-controls {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    gap: 16px;
  }
  
  .pagination-arrow {
    background-color: #1976d2;
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s ease;
    font-size: 16px;
  }
  
  .pagination-arrow i {
    font-size: 20px;
  }
  
  .pagination-arrow:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  .pagination-arrow:hover:not(:disabled) {
    background-color: #145a9e;
  }
  
  
  .close-button {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
  }
  

th,td{
    text-align: center !important;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/views/view-builder/component-positioning/component-positioning.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI;AACJ;AACA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yFAAyF;AAC7F;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,mCAAmC;AACvC;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,eAAe;IACf,aAAa;AACjB;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE;MACE,UAAU;MACV,qBAAqB;IACvB;IACA;MACE,UAAU;MACV,mBAAmB;IACrB;EACF;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,qDAAqD;IACrD,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,gBAAgB,EAAE,gEAAgE;IAClF,gBAAgB,EAAE,0CAA0C;EAC9D;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,sCAAsC;IACtC,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;;AAGF;IACI,6BAA6B;IAC7B","sourcesContent":[".dragged-component:hover {\r\n    background: #d7f3ff;\r\n    border: 1px solid #008fc7;\r\n}\r\n\r\n.builder-actions {\r\n    padding: 0;\r\n    margin: 5px 0 3px 0;\r\n    padding: 0;\r\n}\r\n\r\n.comp-drag-over {\r\n    background: #ff979d;\r\n}\r\n\r\n.drag-target .comp-drag-over {\r\n    background: #ff979d;\r\n}\r\n.bg-new{\r\n    background-color: #faeced  !important\r\n}\r\n.page-container {\r\n    border: 1px solid #00a1ff;\r\n    border-style: dashed;\r\n    border-radius: 5px;\r\n    padding: 0;\r\n    min-height: 78vh;\r\n}\r\n\r\n.add-new-comp {\r\n    background: #008fc7;\r\n    border: 0px !important;\r\n    padding: 0.5em !important;\r\n}\r\n\r\n.plus-icon {\r\n    margin-left: 5px;\r\n}\r\n\r\n.comp-item {\r\n    padding: 0.8em;\r\n    list-style-type: none;\r\n    margin: 0.5em;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n    border: 1px solid #d0d0d0;\r\n}\r\n\r\n.comp-images {\r\n    display: block;\r\n    margin: auto;\r\n    width: 100%;\r\n}\r\n\r\n.comp-name {\r\n    color: white;\r\n    text-align: center;\r\n}\r\n\r\n.comp-item-draggable {\r\n    border: 1px white;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.navbar {\r\n    border-bottom: 1px solid white !important;\r\n}\r\n\r\n.block-actions {\r\n    display: none;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    background: #19b5fe;\r\n    color: #fff;\r\n    padding: 0px 5px;\r\n    border-radius: 0 0px 5px 0px;\r\n}\r\n\r\n.block-actions .fas {\r\n    margin: 0 10px;\r\n}\r\n\r\n.dragged-component:hover .block-actions {\r\n    display: block;\r\n}\r\n\r\n.drop-zone {\r\n    animation-delay: 0s;\r\n    animation-duration: 0.5s;\r\n    background: #d9eaf2;\r\n    border-radius: 5px;\r\n}\r\n\r\n.fas.fa-arrow-left.fa-lg.btn {\r\n    color: #008fc7 !important;\r\n    cursor: pointer;\r\n}\r\n\r\n.preview-builder {\r\n    border: transparent;\r\n    background-color: rgba(0, 143, 199, 0.1);\r\n    padding: 8px 20px;\r\n    color: #008fc7;\r\n}\r\n\r\n.preview-builder.active {\r\n    background-color: #008fc7;\r\n    color: #f2f2f2;\r\n}\r\n\r\n.preview-builder.active:hover {\r\n    background-color: rgba(0, 143, 199, 0.1);\r\n    color: #008fc7;\r\n}\r\n\r\n.brl-5 {\r\n    border-radius: 5px 0 0 5px;\r\n}\r\n\r\n.brr-5 {\r\n    border-radius: 0 5px 5px 0;\r\n}\r\n\r\n.layout-btn {\r\n    margin-right: 20px;\r\n    border-right: 1px solid #ccc;\r\n    padding-right: 20px;\r\n}\r\n\r\n.edit-layout-btn i {\r\n    font-size: 21px;\r\n}\r\n\r\n.iframe-preview {\r\n    height: 100vh;\r\n    border: transparent;\r\n    border-radius: 5px;\r\n}\r\n\r\n.from-template {\r\n    background: #ffecb3;\r\n}\r\n\r\n.from-template .dragged-component {\r\n    background: #ffecb3;\r\n}\r\n\r\n.sizing-block {\r\n    display: block;\r\n    position: absolute;\r\n    bottom: 0;\r\n    top: initial;\r\n    left: initial;\r\n    border-radius: 5px 5px 0px 0px;\r\n    z-index: 10;\r\n    cursor: pointer;\r\n}\r\n\r\n.sizing-pop .col input {\r\n    display: inline-block;\r\n    width: 35px;\r\n}\r\n\r\n.btn.btn-link:hover {\r\n    background: transparent !important;\r\n}\r\n\r\n.searchText {\r\n    color: #fff !important;\r\n}\r\n\r\n.alias-text {\r\n    border: 0;\r\n    border-radius: 5px;\r\n}\r\n\r\n.alias-text:active {\r\n    border: 0;\r\n}\r\n\r\n.alias-text:focus {\r\n    border: 0;\r\n}\r\n\r\n.text-center.add-blocks.action-block.inner {\r\n    right: 15px;\r\n}\r\n\r\n.col-style.col-style-temp .row {\r\n    margin-right: 15px;\r\n    margin-left: 15px;\r\n}\r\n\r\n.row-style.text-center.row {\r\n    padding: 0 25px;\r\n}\r\n\r\n.drag-handle i.fas.fa-arrows-alt {\r\n    z-index: 1;\r\n}\r\n.text-center.add-blocks.action-block.inner {\r\n    right: 0px !important;\r\n}\r\n\r\n.text-center.add-blocks.action-block.inner.inner-col {\r\n    margin-right: 0px !important;\r\n}\r\n\r\n.inner-block {\r\n    background: repeating-linear-gradient(45deg, #e4f3f8, #fff 10px, #e4f3f8 0, #e4f3f8 20px);\r\n}\r\n\r\n.inner-block .text-center {\r\n    padding: 40px 0 40px 0;\r\n    color: #005b88;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n}\r\n.col-style.drag-target{\r\n    border-color: transparent!important;\r\n}\r\n.json-file{\r\n    display: flex;\r\n    justify-content: end;\r\n    font-size: 23px;\r\n    color:#008fc7;\r\n}\r\n.modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n\r\n  .modal-content {\r\n    position: relative;\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\r\n    padding: 24px;\r\n    width: 90%;\r\n    max-width: 800px;\r\n    overflow: hidden;\r\n    animation: fadeIn 0.3s ease;\r\n  }\r\n\r\n  @keyframes fadeIn {\r\n    from {\r\n      opacity: 0;\r\n      transform: scale(0.9);\r\n    }\r\n    to {\r\n      opacity: 1;\r\n      transform: scale(1);\r\n    }\r\n  }\r\n\r\n  .close-button {\r\n    position: absolute;\r\n    top: 16px;\r\n    right: 16px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 24px;\r\n    color: #333;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .header {\r\n    font-size: 1.5rem;\r\n    font-weight: bold;\r\n    margin-bottom: 16px;\r\n    text-align: center;\r\n    color: #1976d2;\r\n  }\r\n\r\n  .search-bar {\r\n    width: 100%;\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .cards-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n    gap: 16px;\r\n  }\r\n\r\n  .card {\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n    background-color: #fff;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .card:hover {\r\n    transform: translateY(-4px);\r\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  .card-image {\r\n    width: 100%;\r\n    height: 150px;\r\n    object-fit: cover;\r\n  }\r\n\r\n  .card-content {\r\n    padding: 16px;\r\n    text-align: left;\r\n  }\r\n\r\n  .card-content h3 {\r\n    font-size: 1.2rem;\r\n    margin: 0 0 8px;\r\n    color: #333;\r\n  }\r\n\r\n  .card-content p {\r\n    margin: 0;\r\n    font-size: 0.9rem;\r\n    color: #666;\r\n  }\r\n\r\n  .pagination-controls {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 24px;\r\n  }\r\n\r\n  .no-templates {\r\n    text-align: center;\r\n    padding: 24px;\r\n  }\r\n\r\n  .no-templates-image {\r\n    width: 100%;\r\n    max-width: 300px;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .no-templates-title {\r\n    font-size: 1.5rem;\r\n    color: #555;\r\n  }\r\n  .modal-content {\r\n    position: relative;\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\r\n    padding: 24px;\r\n    width: 90%;\r\n    max-width: 800px;\r\n    max-height: 90vh; /* Ensure the modal does not exceed 90% of the viewport height */\r\n    overflow-y: auto; /* Enable scrolling for content overflow */\r\n  }\r\n  \r\n  .modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .cards-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n    gap: 16px;\r\n  }\r\n  \r\n  .pagination-controls {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 16px;\r\n    gap: 16px;\r\n  }\r\n  \r\n  .pagination-arrow {\r\n    background-color: #1976d2;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 50%;\r\n    width: 40px;\r\n    height: 40px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .pagination-arrow i {\r\n    font-size: 20px;\r\n  }\r\n  \r\n  .pagination-arrow:disabled {\r\n    background-color: #ccc;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .pagination-arrow:hover:not(:disabled) {\r\n    background-color: #145a9e;\r\n  }\r\n  \r\n  \r\n  .close-button {\r\n    position: absolute;\r\n    top: 16px;\r\n    right: 16px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n\r\nth,td{\r\n    text-align: center !important;\r\n    }\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
